/* eslint-disable no-console */

import { register } from 'register-service-worker';

import { DialogProgrammatic as Dialog } from 'buefy';
window.Dialog = Dialog;

const notifyUserAboutUpdate = worker => {
   Dialog.confirm({
      title: 'Mise à jour !',
      message: "Une mise à jour de l'app a été appliquée, cliquez ci-dessous pour recharger l'environnement.",
      canCancel: false,
      confirmText: 'Mettre à jour',
      type: 'is-success',
      onConfirm: () => {
         worker.postMessage({ action: 'skipWaiting' });
      }
   });
};

if (process.env.NODE_ENV === 'production') {
   register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
         console.log('App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB');
      },
      registered(registration) {
         console.log('Service worker has been registered.');
         setInterval(() => {
            registration.update();
         }, 1000 * 60 * 60); // e.g. hourly checks
      },
      cached() {
         console.log('Content has been cached for offline use.');
      },
      updatefound() {
         console.log('New content is downloading.');
      },
      updated(registration) {
         console.log('New content is available.');
         notifyUserAboutUpdate(registration.waiting);
      },
      offline() {
         console.log('No internet connection found. App is running in offline mode.');
      },
      error(error) {
         console.error('Error during service worker registration:', error);
      }
   });

   var refreshing;
   if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', function() {
         if (refreshing) return;
         window.location.reload();
         refreshing = true;
      });
   }
}
